import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {SplitText} from 'gsap/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      $( `
      .js-fade:not(.js-ignore),
      .js-reveal:not(.js-ignore),
      .js-fade-group,
      .wysiwyg--animate,
      .js-split-lines
      ` ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              if ( $( this ).hasClass( 'js-fade-group' ) ) {
                $( this ).find( '> *' ).each( function( childKey, child ) {
                  const delay = ( childKey + 1 ) / 10;
                  child.style.setProperty( '--fade-group-delay', delay + 's' );
                } );
              }
              $( this ).addClass( 'js-animated' );
            },
          },
        } );
      } );

      const splitClasses = '.js-split-lines:not(.js-ignore), .wysiwyg--animate [class*="hdg-"], .wysiwyg--animate > h1:not([class*="hdg-"], [class*="paragraph-"]), .wysiwyg--animate > h2:not([class*="hdg-"], [class*="paragraph-"]), .wysiwyg--animate > h3:not([class*="hdg-"], [class*="paragraph-"]), .wysiwyg--animate > h4:not([class*="hdg-"], [class*="paragraph-"]), .wysiwyg--animate > h5:not([class*="hdg-"], [class*="paragraph-"]), .wysiwyg--animate > h6:not([class*="hdg-"], [class*="paragraph-"])';

      document.querySelectorAll( splitClasses ).forEach( ( el ) => {
        const text = new SplitText( el, {
          type: 'lines',
          linesClass: 'line--child',
          reduceWhiteSpace: false,
        } );

        const mask = new SplitText( el, {
          type: 'lines',
          linesClass: 'line--parent',
          reduceWhiteSpace: false,
        } );

        $( el ).addClass( 'js-split-words--target' );

        gsap.from( text.lines, {
          yPercent: 200,
          duration: 0.75,
          stagger: 0.1,
          ease: 'power4.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%', // Triggers when the section enters the viewport
            toggleActions: 'play none none none', // Plays once when scrolled to
            onEnter: () => {
              $( el ).addClass( 'js-animated' );
            },
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( el ).addClass( 'js-animated' );
              }
            },
          },
        } );
      } );
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
